/*@ngInject*/
const UIDataItemDragManagerDirective = function ($rootScope, configurationConstant, dataSetEditorModel) {

    var linkFunction = function ($scope, $elm, $attr) {

        var element = $($elm),
            dataSetName = $scope.dataItemView.dataSetName,
            isTopDropAttempt,
            isBottomDropAttempt;

        function onDragStart(event) {
            var isDraggingDataItem = _.includes(event.target.classList, 'dataItemsGroupTableRow'),

                dataTransfer,
                dragDropConfiguration;

            if (isDraggingDataItem) {
                if ($scope.dataItemView.mouseDown) {
                    dataTransfer = event.originalEvent.dataTransfer;
                    dragDropConfiguration = {
                        dragDataItemsGroupId: $scope.dataItemView.groupId
                    };

                    dataSetEditorModel.setDraggingDataItems(dataSetName, true);

                    element.addClass('draggingDataItem');
                    if (!$scope.dataItemView.selected) {
                        $rootScope.$broadcast(configurationConstant.event.DATA_SET_ITEM_DRAG_DROP_FROM_UNSELECTED_ROW, {
                            dataItemId: $scope.dataItemView.id,
                            dataItemsGroupId: $scope.dataItemView.groupId
                        });
                    } else {
                        $('.dataItemsGroupTableRow.selected').each(function (index, selectedItem) {
                            $(selectedItem).addClass('draggingDataItem');
                        });
                    }

                    // Disable pointer events on all data item cells in the UI to prevent issues
                    $('.dataItemsGroupTableRowCell').each(function (index, selectedItem) {
                        $(selectedItem).css('pointer-events', 'none');
                    });

                    dataTransfer.setData('text', JSON.stringify(dragDropConfiguration));
                    dataTransfer.effectAllowed = 'move';
                } else {
                    event.preventDefault();
                }
            }
        }

        function onDragOver(event) {
            var dataTransfer = event.originalEvent.dataTransfer,
                currentDropTarget = $(event.currentTarget),
                isElementBeingDragged = currentDropTarget.hasClass('draggingDataItem'),
                isDraggingDataItems = dataSetEditorModel.isDraggingDataItems(dataSetName),
                isLastChild = currentDropTarget.is(':last-child'),
                isFirstChild = currentDropTarget.is(':first-child'),
                moveAllowed = false,
                offsetY,
                halfheight;

            if (!isElementBeingDragged && isDraggingDataItems) {
                offsetY = event.offsetY;
                halfheight = currentDropTarget.height() / 2;
                isTopDropAttempt = offsetY < halfheight;
                isBottomDropAttempt = offsetY >= halfheight;

                currentDropTarget.removeClass('dragOverTopDataItem');
                currentDropTarget.removeClass('dragOverBottomDataItem');

                if (isTopDropAttempt) {
                    currentDropTarget.addClass('dragOverTopDataItem');
                    moveAllowed = true;
                } else if (isBottomDropAttempt && !isLastChild) {
                    currentDropTarget.addClass('dragOverBottomDataItem');
                    moveAllowed = true;
                }

                if (moveAllowed) {
                    dataTransfer.dropEffect = 'move';
                    event.preventDefault();
                }
            }
        }

        function onDragLeave(event) {
            var currentDropTarget = $(event.currentTarget);

            currentDropTarget.removeClass('dragOverTopDataItem');
            currentDropTarget.removeClass('dragOverBottomDataItem');
        }

        function onDrop(event) {
            var dataTransfer = event.originalEvent.dataTransfer,
                dragDropConfiguration = JSON.parse(dataTransfer.getData('text')),
                currentDropTarget = $(event.currentTarget),
                isDraggingDataItems = dataSetEditorModel.isDraggingDataItems(dataSetName);

            if (isDraggingDataItems) {
                handleDropOperation(currentDropTarget, dragDropConfiguration);

                event.preventDefault();
                return false;
            }
        }

        function handleDropOperation(currentDropTarget, dragDropConfiguration) {
            var takeAction = isTopDropAttempt || isBottomDropAttempt;

            element.removeClass('draggingDataItem');
            currentDropTarget.removeClass('dragOverTopDataItem');
            currentDropTarget.removeClass('dragOverBottomDataItem');

            if (takeAction) {
                dragDropConfiguration.dropDataItemId = $scope.dataItemView.id;
                dragDropConfiguration.dropDataItemsGroupId = $scope.dataItemView.groupId;

                if (isTopDropAttempt) {
                    dragDropConfiguration.type = configurationConstant.dataSet.INSERT_BEFORE;
                } else if (isBottomDropAttempt) {
                    dragDropConfiguration.type = configurationConstant.dataSet.INSERT_AFTER;
                }

                $rootScope.$broadcast(configurationConstant.event.DATA_SET_ITEM_DRAG_DROP, dragDropConfiguration);
            }
        }

        function onDragEnd() {
            element.removeClass('draggingDataItem');
            $('.dataItemsGroupTableRow.selected').each(function (index, selectedItem) {
                $(selectedItem).removeClass('draggingDataItem');
            });

            $('.dataItemsGroupTableRowCell').each(function (index, selectedItem) {
                $(selectedItem).css('pointer-events', 'auto');
            });

            dataSetEditorModel.setDraggingDataItems(dataSetName, false);
        }

        element.on('dragstart', onDragStart);
        element.on('dragover', onDragOver);
        element.on('dragleave', onDragLeave);
        element.on('drop', onDrop);
        element.on('dragend', onDragEnd);

        $scope.$on('$destroy', function () {
            element.off('dragstart', onDragStart);
            element.off('dragover', onDragOver);
            element.off('dragleave', onDragLeave);
            element.off('drop', onDrop);
            element.off('dragend', onDragEnd);
        });
    };

    return {
        link: linkFunction,
        restrict: 'A'
    };
};

angular.module('umCore')
    .directive('uiDataItemDragManager', UIDataItemDragManagerDirective);
